class ProductPrice {
    /**
     * @type {number|null}
     */
    taxRate;
    /**
     * @type {string}
     */
    currencyIso4217;
    /**
     * @type {number|null}
     */
    quantityMin;
    /**
     * @type {number}
     */
    price;

    /**
     * @param dto {ProductPrice}
     */
    constructor(dto) {
        this.taxRate = dto.taxRate;
        this.currencyIso4217 = dto.currencyIso4217;
        this.quantityMin = dto.quantityMin;
        this.price = dto.price;
    }
}

class ProductAttachment {
    /**
     * @type {string}
     */
    mimeType;

    /**
     * deeplink to image
     * @type {string}
     */
    src;

    /**
     * @type {string}
     */
    title;

    /**
     * @type {string}
     */
    description;

    /**
     * @type {string}
     */
    alternativeText;


    /**
     * @param dto {ProductAttachment}
     */
    constructor(dto) {
        this.mimeType = dto.mimeType;
        this.src = dto.src;
        this.title = dto.title;
        this.description = dto.description;
        this.alternativeText = dto.alternativeText;
    }
}

class ProductDescription {
    /**
     * @type {string}
     */
    name;
    /**
     * @type {string}
     */
    text;

    /**
     * @param dto {ProductDescription}
     */
    constructor(dto) {
        this.name = dto.name;
        this.text = dto.text;
    }
}

class ProductUnit {
    /**
     * unece format
     * @type {string}
     */
    orderUnit;

    /**
     * unece format
     * @type {string}
     */
    contentUnit;

    /**
     * @type {number}
     */
    contentUnitsPerOrderUnit;


    /**
     *
     * @param dto {ProductUnit}
     */
    constructor(dto) {
        this.orderUnit = dto.orderUnit;
        this.contentUnit = dto.contentUnit;
        this.contentUnitsPerOrderUnit = dto.contentUnitsPerOrderUnit;
    }
}

class OciProduct {
    /**
     * @type {string}
     */
    id;

    /**
     * @type {ProductPrice}
     */
    price;

    /**
     * @type {ProductDescription}
     */
    description;

    /**
     * @type {string}
     */
    manufactCode;

    /**
     * @type {string}
     */
    manufactMat;

    /**
     * @type {ProductUnit}
     */
    unit;

    /**
     * @type {string}
     */
    attachment;

    /**
     * @type {string}
     */
    attachmentTitle;

    /**
     * @param dto {OciProduct}
     */
    constructor(dto) {
        this.id = dto.id;
        this.price = new ProductPrice(dto.price)
        this.description = new ProductDescription(dto.description);
        this.manufactCode = dto.manufactCode;
        this.manufactMat = dto.manufactMat;
        this.unit = new ProductUnit(dto.unit);
        this.attachment = dto.attachment;
        this.attachmentTitle = dto.attachmentTitle;
    }

    /**
     * Checks if the product has valid unit info
     * @returns {boolean}
     */
    get hasUnits() {
        return !!(this.unit?.contentUnit && this.unit?.orderUnit);
    }

}

module.exports = OciProduct;